import LookalikeSizePreview from './LookalikeSizePreview.Container';

export default LookalikeSizePreview;
